/**
 * Created by 唐亦慧 on 2017/8/29.
 */
import {config, request} from 'Utils';

//授信列表接口
export function categoryList(param) {
	return request(`${config.server}/api/v1/dms/dmsErpCredit/creditList`,{
		method: 'post',
		body: param
	});
}

/*客户名称接口*/
export function customerScreening(param) {
    return request(`${config.server}/api/v1/dms/employee/customerList/${param}`,{
        method: 'get'
    });
}


// WEBPACK FOOTER //
// ./src/service/creditChange/index.js